import React from "react";
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";
import { usePhoneMode } from "../../hooks";

export default function EngineInfoModelTab({ rows }) {
    const { isMobile } = usePhoneMode();
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height;

    let heightOffset = '9.0em';
    if(isMobile) {
        heightOffset = '7.0em';
    }

    return (
        <div>
            <TableContainer style={{ maxHeight: `calc(100vh - ${scrollViewerTop}px - ${heightOffset})` }}>
                <Table stickyHeader size={isMobile ? "small" : "medium"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Attribute</TableCell>
                            <TableCell>Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <StyledTableRow key={index}>
                                <TableCell>{row.attribute}</TableCell>
                                <TableCell>{row.value}</TableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));